import { render, staticRenderFns } from "./AlarmRedirect.vue?vue&type=template&id=dd08a696&"
import script from "./AlarmRedirect.vue?vue&type=script&lang=js&"
export * from "./AlarmRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports